// Each practice app's tile for the app switcher (client 2026-11-03), named
// after the app. Imported rather than served from public/ so the build hashes
// them into /assets and the service worker precaches them: the switcher must
// show them offline too.
import quarterback from "./quarterback.svg";
import runningBack from "./running-back.svg";
import tightEnd from "./tight-end.svg";
import offensiveLine from "./offensive-line.svg";
import wideReceiver from "./wide-receiver.svg";
import linebacker from "./linebacker.svg";
import safety from "./safety.svg";
import defensiveLine from "./defensive-line.svg";
import defensiveBack from "./defensive-back.svg";
import defensiveCoordinator from "./defensive-coordinator.svg";
import specialTeams from "./special-teams.svg";
import practice from "./practice.svg";

/** By app id (the /qb, /rb… paths). */
export const APP_ICONS: Readonly<Record<string, string | undefined>> = {
  qb: quarterback,
  rb: runningBack,
  te: tightEnd,
  ol: offensiveLine,
  wr: wideReceiver,
  lb: linebacker,
  s: safety,
  dl: defensiveLine,
  db: defensiveBack,
  dc: defensiveCoordinator,
  st: specialTeams,
  def: practice,
};
